import { Component } from "@angular/core";
import { CourseResponse } from "src/app/interfaces/response";

@Component({
  selector: "app-renap-home",
  templateUrl: "./renap-home.component.html",
  styleUrls: ["./renap-home.component.css"],
})
export class RenapHomeComponent {
  selectedCourse: CourseResponse | null = null;
  idCorso: number | null;

  public onCourseSelected(course: any): void {
    this.selectedCourse = course;
    this.idCorso = course.idCurso;
    window.scroll(0, 0);
  }

  public closeDetail(): void {
    this.selectedCourse = null;
  }
}
